import { apiClient } from '../../../api/client'
import { downloadXlsx } from '../../../lib/download'
import type {
  ModuleOption,
  OperationCode,
  OperationCodeUpdate,
  PagedResponse,
} from '../types'

const BASE = '/management/operation-codes'

export interface OperationCodeQuery {
  /** Ad araması (TR veya EN); boş ise gönderilmez. */
  q?: string
  /** Modül filtresi (REFERANS id); `null` = Tümü → gönderilmez. */
  moduleId?: number | null
  page: number
  size: number
}

/**
 * İşlem kodu listesi (045) — **sunucu-tarafı** sayfalama + filtreleme. `sort` parametresi
 * **gönderilmez**: düzen sunucuda sabittir (MODULE_ID, ID).
 */
export async function getOperationCodes({
  q,
  moduleId,
  page,
  size,
}: OperationCodeQuery): Promise<PagedResponse<OperationCode>> {
  const { data } = await apiClient.get<PagedResponse<OperationCode>>(BASE, {
    params: {
      page,
      size,
      q: q && q.trim() ? q.trim() : undefined,
      moduleId: moduleId ?? undefined,
    },
  })
  return data
}

/** Modül filtre seçenekleri (aktif REFERANS TYPE=MODULE, SORT_INDEX düzeninde). */
export async function getOperationCodeModules(): Promise<ModuleOption[]> {
  const { data } = await apiClient.get<ModuleOption[]>(`${BASE}/modules`)
  return data
}

/** İşlem kodu ad (TR/EN) güncelleme (045). Modül/durum değişmez; modDate optimistic lock. */
export async function updateOperationCode(
  id: number,
  body: OperationCodeUpdate,
): Promise<OperationCode> {
  const { data } = await apiClient.put<OperationCode>(`${BASE}/${id}`, body)
  return data
}

/**
 * İşlem kodu listesini Excel (.xlsx) olarak indirir.
 *
 * Liste ucuyla aynı filtreler; sunucu **tüm** filtreli kayıtları döndürür (sayfalama yok). İndirme
 * mekaniği ve dosya adı ortak {@link downloadXlsx} yardımcısındadır (boş filtreler gönderilmez; ad
 * sunucunun Content-Disposition'ından okunur).
 */
export async function exportOperationCodes(q?: string, moduleId?: number): Promise<void> {
  await downloadXlsx(`${BASE}/export`, { q, moduleId }, 'islem-kodlari.xlsx')
}
